module.exports = __webpack_public_path__ + "img/mikeBg@2x.8c10990a.jpg";